/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_1_VInputs */

const en_cp_fact_1_v = /** @type {(inputs: Cp_Fact_1_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 stages`)
};

const id_cp_fact_1_v = /** @type {(inputs: Cp_Fact_1_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 langkah`)
};

/**
* | output |
* | --- |
* | "4 stages" |
*
* @param {Cp_Fact_1_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_1_v = /** @type {((inputs?: Cp_Fact_1_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_1_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_1_v(inputs)
	return en_cp_fact_1_v(inputs)
});